import { FaPhoneAlt } from "react-icons/fa";
import { useState } from "react";
import EnrollModal from "../components/EnrollModal";
import "../styles/TrendingBanner.css";

export default function TrendingBanner() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <section className="trending-wrapper">
        <h3 className="trending-title">What's Trending</h3>

        <div className="trending-card">
          {/* Decorative shapes */}
          <span className="shape shape-1"></span>
          <span className="shape shape-2"></span>

          {/* LEFT CONTENT */}
          <div className="trending-content">
            <h2>
              Your Journey to<span> Excellence Begins With <img src="/images/access.png"
              alt="ACCESS"
              className="acces-img"/></span>
            </h2>

            <p className="date">
              Register for bridge course <strong>Classes started on 6th April 2026</strong>
            </p>

            <div className="cta-row">
              <button className="enrol-btn">
                Call Now <a href="tel:+919964585585" className="call-btn">
                          <FaPhoneAlt /> 
                        </a>
              </button>

              <p className="tc">
                T&amp;C apply. Applicable for{" "}
                <u>ACCESS Classroom Courses</u> only.
              </p>
            </div>
          </div>

          {/* RIGHT IMAGE */}
          <div className="trending-image">
            <img
              src="/images/img1.jpeg"
              alt="Student"
            />
          </div>
        </div>
      </section>

      {/* ENROLL MODAL */}
      <EnrollModal
        isOpen={open}
        onClose={() => setOpen(false)}
        courseName="ACCESS Classroom Courses"
      />
    </>
  );
}
